import { createContext } from 'react';
import Layout from '../../../../../@Api/Layout/Layout';

export default createContext<Layout[]>([]);
